module.exports = __webpack_public_path__ + "img/close.379f292d.png";